<template>
  <div class="contact-pricing">
    <app-header :background-name="'wallpaper3.jpg'">
      <h1>Stéphanie Lefebvre</h1>
      <h2>Contact</h2>
    </app-header>

    <div class="content article">
      <h1 class="name">Consultations sur rendez-vous à Essars</h1>

      <h3>Une séance complète dure environ <span>1h30</span>. </h3>
      <h3>C'est dans <span>l'écoute et avec un profond respect</span> que vous serez accueilli.</h3>

      <br />

      <article>
        <div class="bloc price-content">
          <div class="price-card first">
            <h3>* Reiki – LaHoChi – Shiatsu – Réflexologie plantaire Thaïe Traditionnelle</h3>
            <p class="price">
              - Ado et Adulte : <b>50</b> euros la séance
            </p>
            <p>
              - Enfant jusqu'à 12 ans : <b>35</b> euros la séance
            </p>

            <br>
            <h3>* Massage des 5 Continents</h3>
            <p class="price">
              - Séance de 1h30 : <b>75</b> euros
            </p>

            <br>
            <h4>Règlement uniquement par chèque bancaire ou en espèces.</h4>
          </div>
        </div>
      </article>

      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSdKIe5710FEq5wBkNcPRxaTJkocsS8VfSQyfrFGhkT9cUSMJw/viewform?embedded=true"
        class="form" width="100%" height="1000" frameborder="0" marginheight="0" marginwidth="0">Chargement…
      </iframe>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/Header'

export default {
  name: 'ContactEssars',
  components: { AppHeader }
}
</script>

<style lang="scss" scoped>
.contact-pricing {
  display: flex;
  flex-direction: column;
  flex: 1;

  .content {
    position: relative;
    text-align: center;
    background-color: #f1fae7;
    align-items: center;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media screen and (max-width: 680px) {
      overflow: auto;
    }


    h4 {
      margin: .5em;
      font-weight: 300;
      font-size: 1.1em;
      font-family: 'Delius', cursive;
      text-align: center;

      &.custom {
        border-bottom: 2px solid $color-green;
          margin-bottom: 2em;
        font-weight: 700;
      }
    }


    article {
      @include custom-article();
      width: 50%;

      p,
      span,
      h3 {
        text-align: center;
      }
    }


    .price-content {
      .price-card {
        background: white;

        h3 {
          margin-top: .5em;
          color: $color-green;
        }

        p {
          margin-bottom: 0;
        }
      }

    }

    .form {
      margin-top: 1em;
    }

    h3 {
      margin: 0;

      span {
        color: $color-green;
      }
    }
  }
}
</style>
